import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import { updateTemplateWidthB, updateTemplateWidthR, updateTemplateWidthL, updateTemplateWidthF } from "./leanBuilding.helper";

const updateJTrimForLeanTo = (state, type) => {
	const { params, const_var } = state;
	let checkEndJTrim;
	let checkSideJTrim = false;

	if (type == "sideJTrim") {
		if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
			checkSideJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
		}
		if (checkSideJTrim && ((params.p_r_w != "Open" && params.p_r_w != "Close") || (params.p_l_w != "Open" && params.p_l_w != "Close"))) {
			params.p_j_t = true;
		}
	} else if (type == "endJTrim") {
		if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
			checkEndJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		}
		if (checkEndJTrim && ((params.p_f_w != "Open" && params.p_f_w != "Close") || (params.p_b_w != "Open" && params.p_b_w != "Close"))) {
			params.p_j_t_end = true;
		}
	} else {
		if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
			checkSideJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
			checkEndJTrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		}
		if (checkSideJTrim && ((params.p_r_w != "Open" && params.p_r_w != "Close") || (params.p_l_w != "Open" && params.p_l_w != "Close"))) {
			params.p_j_t = true;
		}
		if (
			checkEndJTrim &&
			((params.p_f_w != "Open" && params.p_f_w != "Close" && params.p_f_w != "Half Dutch End" && params.p_f_w != "Half End") ||
				(params.p_b_w != "Open" && params.p_b_w != "Close" && params.p_b_w != "Half Dutch End" && params.p_b_w != "Half End") ||
				(params.p_b_c_b_l_f != "Open" && params.p_b_c_b_l_f != "Close" && params.p_b_c_b_l_f != "Half Dutch End" && params.p_b_c_b_l_f != "Half End") ||
				(params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close" && params.p_b_c_b_l_b != "Half Dutch End" && params.p_b_c_b_l_b != "Half End") ||
				(params.p_b_c_b_b_f != "Open" && params.p_b_c_b_b_f != "Close" && params.p_b_c_b_b_f != "Half Dutch End" && params.p_b_c_b_b_f != "Half End") ||
				(params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close" && params.p_b_c_b_b_b != "Half Dutch End" && params.p_b_c_b_b_b != "Half End") ||
				(params.p_b_c_b_f_f != "Open" && params.p_b_c_b_f_f != "Close" && params.p_b_c_b_f_f != "Half Dutch End" && params.p_b_c_b_f_f != "Half End") ||
				(params.p_b_c_b_f_b != "Open" && params.p_b_c_b_f_b != "Close" && params.p_b_c_b_f_b != "Half Dutch End" && params.p_b_c_b_f_b != "Half End") ||
				(params.p_b_c_b_r_f != "Open" && params.p_b_c_b_r_f != "Close" && params.p_b_c_b_r_f != "Half Dutch End" && params.p_b_c_b_r_f != "Half End") ||
				(params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close" && params.p_b_c_b_r_b != "Half Dutch End" && params.p_b_c_b_r_b != "Half End"))
		) {
			params.p_j_t_end = true;
		}
	}
};

export const fullyWallEnclosedFrontLeanTo = (state) => {
	const { params, const_var } = state;
	const is_GableLeanBackWall = state.params.leanStyle.front !== "gable" || (state.params.leanStyle.front === "gable" && state.params.p_f_w !== "Close");

	if (state.isFullyEnclosedCheckedForFrontLeanTo) {
		state.params.p_c_a_f_l_w = true;
		state.params.p_b_c_b_f_l = "Close";
		state.params.prev_p_b_c_b_f_b = "Close";
		state.params.p_b_c_b_f_f = "Close";
		state.params.prev_p_b_c_b_f_f = "Close";
		state.params.b_f_l_t_l = "Close";
		state.params.b_f_l_t_r = "Close";
		state.params.b_f_l_t_f = "Close";
		if (is_GableLeanBackWall) {
			state.params.p_b_c_b_f_b = "Close";
		} else {
			state.params.p_b_c_b_f_b = "Open";
		}
		if (state.params.leanStyle.front === "gable") {
			state.params.p_b_c_b_f_r = "Close";
		}
	} else {
		state.params.add_storage_check_front = false;
		state.params.p_c_a_f_l_w = false;
		state.params.p_b_c_b_f_l = "Open";
		state.params.p_b_c_b_f_b = "Open";
		state.params.p_b_c_b_f_f = "Open";
		state.params.b_f_l_t_f = "Open";
		state.params.b_f_l_t_l = "Open";
		state.params.b_f_l_t_r = "Open";
		state.params.prev_p_b_c_b_f_f = "Open";
		state.params.prev_p_b_c_b_f_b = "Open";
		if (state.params.leanStyle.front === "gable") {
			state.params.p_b_c_b_f_r = "Open";
		}
	}
	if ((!is_GableLeanBackWall || state.params.p_b_c_b_f_b == "Close") && state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_f == "Close") {
		if (state.params.leanStyle.front === "gable") {
			if (state.params.p_b_c_b_f_r == "Close") {
				const_var.setLeanWallOption.frontLean = "close";
			}
		} else {
			const_var.setLeanWallOption.frontLean = "close";
		}
	} else if (state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_b == "Open" && state.params.p_b_c_b_f_f == "Open") {
		if (state.params.leanStyle.front === "gable") {
			if (state.params.p_b_c_b_f_r == "Open") {
				const_var.setLeanWallOption.frontLean = "open";
			}
		} else {
			const_var.setLeanWallOption.frontLean = "open";
		}
	}
	const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
	const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;
	const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
	const_var.UpdatedPriceData.front_lean_right_wall_price_changed = true;
	const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;
	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) {
		const_var.UpdatedPriceData.insulation_price = undefined;
	}
	const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
	state.params.p_c_p_r = false;
	state.params.p_c_p_f = false;
	cuBuilding.BuildingUpdate(true, "leanwall");
	cuBuilding.UpdateFrontLean("walls");
	cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
};

export const fullyWallEnclosedBackLeanTo = (state) => {
	const { params, const_var } = state;
	const is_GableLeanBackWall = state.params.leanStyle.back !== "gable" || (state.params.leanStyle.back === "gable" && state.params.p_b_w !== "Close");

	if (state.isFullyEnclosedCheckedForBackLeanTo) {
		state.params.p_c_a_b_l_w = true;
		state.params.p_b_c_b_b_l = "Close";
		state.params.p_b_c_b_b_f = "Close";
		state.params.prev_p_b_c_b_b_f = "Close";
		state.params.prev_p_b_c_b_b_b = "Close";
		state.params.b_b_l_t_l = "Close";
		state.params.b_b_l_t_r = "Close";
		state.params.b_b_l_t_f = "Close";
		if (is_GableLeanBackWall) {
			state.params.p_b_c_b_b_b = "Close";
		} else {
			state.params.p_b_c_b_b_b = "Open";
		}
		if (state.params.leanStyle.back == "gable") {
			state.params.p_b_c_b_b_r = "Close";
		}
	} else {
		state.params.add_storage_check_back = false;
		state.params.p_c_a_b_l_w = false;
		state.params.p_b_c_b_b_l = "Open";
		state.params.p_b_c_b_b_f = "Open";
		state.params.p_b_c_b_b_b = "Open";
		state.params.b_b_l_t_f = "Open";
		state.params.b_b_l_t_l = "Open";
		state.params.b_b_l_t_r = "Open";
		state.params.prev_p_b_c_b_b_f = "Open";
		state.params.prev_p_b_c_b_b_b = "Open";
		if (state.params.leanStyle.back == "gable") {
			state.params.p_b_c_b_b_r = "Open";
		}
	}
	if ((!is_GableLeanBackWall || state.params.p_b_c_b_b_b == "Close") && state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_f == "Close") {
		if (state.params.leanStyle.back == "gable") {
			if (state.params.p_b_c_b_b_r == "Close") {
				const_var.setLeanWallOption.backLean = "close";
			}
		} else {
			const_var.setLeanWallOption.backLean = "close";
		}
	} else if (state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open") {
		if (state.params.leanStyle.back == "gable") {
			if (state.params.p_b_c_b_b_r == "Open") {
				const_var.setLeanWallOption.backLean = "open";
			}
		} else {
			const_var.setLeanWallOption.backLean = "open";
		}
	}
	const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
	const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;
	const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
	const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
	const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) {
		const_var.UpdatedPriceData.insulation_price = undefined;
	}
	const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
	state.params.p_c_p_r = false;
	state.params.p_c_p_l = false;
	cuBuilding.BuildingUpdate(true, "leanwall");
	cuBuilding.UpdateBackLean("walls");
	cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
};

export const fullyWallEnclosedLeftLeanTo = (state) => {
	const { params, const_var } = state;
	const is_GableLeanBackWall = state.params.leanStyle.left !== "gable" || (state.params.leanStyle.left === "gable" && state.params.p_l_w !== "Close");

	if (state.isFullyEnclosedCheckedForLeftLeanTo) {
		state.params.p_c_a_l_l_w = true;
		state.params.p_b_c_b_l_f = "Close";
		state.params.prev_p_b_c_b_l_f = "Close";
		state.params.prev_p_b_c_b_l_b = "Close";
		state.params.p_b_c_b_l = "Close";
		state.params.b_l_l_t_l = "Close";
		state.params.b_l_l_t_r = "Close";
		state.params.b_l_l_t_b = "Close";
		state.params.b_l_l_t_f = "Close";
		if (is_GableLeanBackWall) {
			state.params.p_b_c_b_l_b = "Close";
		} else {
			state.params.p_b_c_b_l_b = "Open";
		}
		if (state.params.leanStyle.left == "gable") {
			state.params.p_b_c_b_l_r = "Close";
		}
	} else {
		state.params.add_storage_check = false;
		state.params.p_c_a_l_l_w = false;
		state.params.p_b_c_b_l_f = "Open";
		state.params.p_b_c_b_l_b = "Open";
		state.params.p_b_c_b_l = "Open";
		state.params.b_l_l_t_l = "Open";
		state.params.b_l_l_t_r = "Open";
		state.params.b_l_l_t_b = "Open";
		state.params.b_l_l_t_f = "Open";
		state.params.prev_p_b_c_b_l_f = "Open";
		state.params.prev_p_b_c_b_l_b = "Open";
		if (state.params.leanStyle.left == "gable") {
			state.params.p_b_c_b_l_r = "Open";
		}
	}
	if ((!is_GableLeanBackWall || state.params.p_b_c_b_l_b == "Close") && state.params.p_b_c_b_l == "Close" && state.params.p_b_c_b_l_f == "Close") {
		if (state.params.leanStyle.left == "gable") {
			if (state.params.p_b_c_b_l_r == "Close") {
				const_var.setLeanWallOption.leftLean = "close";
			}
		} else {
			const_var.setLeanWallOption.leftLean = "close";
		}
	} else if (state.params.p_b_c_b_l == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l_f == "Open") {
		if (state.params.leanStyle.left == "gable") {
			if (state.params.p_b_c_b_l_r == "Open") {
				const_var.setLeanWallOption.leftLean = "open";
			}
		} else {
			const_var.setLeanWallOption.leftLean = "open";
		}
	}
	const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
	const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
	const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
	const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
	const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) {
		const_var.UpdatedPriceData.insulation_price = undefined;
	}
	const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
	state.params.p_c_p_r = false;
	state.params.p_c_p_l = false;
	cuBuilding.BuildingUpdate(true, "leanwall");
	cuBuilding.UpdateLeftLean("walls");
	cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
};

export const fullyWallEnclosedRightLeanTo = (state) => {
	const { params, const_var } = state;
	const is_GableLeanBackWall = state.params.leanStyle.right !== "gable" || (state.params.leanStyle.right === "gable" && state.params.p_r_w !== "Close");

	if (state.isFullyEnclosedCheckedForRightLeanTo) {
		state.params.p_c_a_r_l_w = true;
		state.params.p_b_c_b_r_f = "Close";
		state.params.prev_p_b_c_b_r_f = "Close";
		state.params.prev_p_b_c_b_r_b = "Close";
		state.params.p_b_c_b_r = "Close";
		state.params.b_r_l_t_r = "Close";
		state.params.b_r_l_t_b = "Close";
		state.params.b_r_l_t_f = "Close";
		state.params.b_r_l_t_l = "Close";
		if (is_GableLeanBackWall) {
			state.params.p_b_c_b_r_b = "Close";
		} else {
			state.params.p_b_c_b_r_b = "Open";
		}
		if (state.params.leanStyle.right === "gable") {
			state.params.p_b_c_b_r_r = "Close";
		}
	} else {
		state.params.add_storage_check_right = false;
		state.params.p_c_a_r_l_w = false;
		state.params.p_b_c_b_r_f = "Open";
		state.params.p_b_c_b_r_b = "Open";
		state.params.p_b_c_b_r = "Open";
		state.params.b_r_l_t_r = "Open";
		state.params.b_r_l_t_b = "Open";
		state.params.b_r_l_t_f = "Open";
		state.params.b_r_l_t_l = "Open";
		state.params.prev_p_b_c_b_r_f = "Open";
		state.params.prev_p_b_c_b_r_b = "Open";
		if (state.params.leanStyle.right === "gable") {
			state.params.p_b_c_b_r_r = "Open";
		}
	}
	if ((!is_GableLeanBackWall || state.params.p_b_c_b_r_b == "Close") && state.params.p_b_c_b_r == "Close" && state.params.p_b_c_b_r_f == "Close") {
		if (state.params.leanStyle.right === "gable") {
			if (state.params.p_b_c_b_r_r == "Close") {
				const_var.setLeanWallOption.rightLean = "close";
			}
		} else {
			const_var.setLeanWallOption.rightLean = "close";
		}
	} else if (state.params.p_b_c_b_r == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r_f == "Open") {
		if (state.params.leanStyle.right === "gable") {
			if (state.params.p_b_c_b_r_r == "Open") {
				const_var.setLeanWallOption.rightLean = "open";
			}
		} else {
			const_var.setLeanWallOption.rightLean = "open";
		}
	}
	const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
	const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
	const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
	const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
	const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
	const_var.UpdatedPriceData.wainscot_price_changed = true;
	if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
		const_var.UpdatedPriceData.certificate_price_changed = true;
	}
	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.surcharge_amount = undefined;
	if (const_var.isInsulaltionForOldQuotes && params.p_i_o != 0) {
		const_var.UpdatedPriceData.insulation_price = undefined;
	}
	const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
	state.params.p_c_p_r = false;
	state.params.p_c_p_l = false;
	cuBuilding.BuildingUpdate(true, "leanwall");
	cuBuilding.UpdateRightLean("walls");
	cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
};

export const dynamicWallOptionsForLeanTo = (state) => {
	const { params, const_var } = state;

	state.const_var.a_p_d_a = state.const_var.a_p_d_a && typeof state.const_var.a_p_d_a === "object" ? state.const_var.a_p_d_a : {};
	if (!Array.isArray(state.const_var.a_p_d_a.panel)) {
		state.const_var.a_p_d_a.panel = [];
	}
	if (!Array.isArray(state.const_var.a_p_d_a.gable_end)) {
		state.const_var.a_p_d_a.gable_end = [];
	}

	if (params.add_front_lean) cuBuilding.UpdateFrontLean();
	if (params.add_left_lean) cuBuilding.UpdateLeftLean();
	if (params.add_right_lean) cuBuilding.UpdateRightLean();
	if (params.add_back_lean) cuBuilding.UpdateBackLean();
	state.frontlentoEnds = {};
	state.frontlentoSides = {};
	state.backlentoEnds = {};
	state.backlentoSides = {};
	state.leftlentoEnds = {};
	state.leftlentoSides = {};
	state.rightlentoEnds = {};
	state.rightlentoSides = {};

	let showRemainingWallOption = true;
	let isOlderThen12June =
		const_var.crmSetting.is_Edit == true &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data != undefined &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at != undefined &&
		const_var.editAPIDataByResponse.data.main_created_at <= "2024-06-12"
			? true
			: false;

	if (
		const_var.crmSetting.is_Edit == true &&
		const_var.editAPIDataByResponse != undefined &&
		const_var.editAPIDataByResponse.data != undefined &&
		const_var.editAPIDataByResponse.data.request_data != undefined &&
		const_var.editAPIDataByResponse.data.request_data.building != undefined &&
		const_var.editAPIDataByResponse.data.request_data.building.create_at_date != undefined &&
		const_var.editAPIDataByResponse.data.request_data.building.create_at_date <= "2024-06-12"
	) {
		isOlderThen12June = true;
	}

	if (!isOlderThen12June && (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97 || params.m_s_n == 13)) {
		showRemainingWallOption = false;
	}
	if (const_var.crmSetting.is_Edit == true) {
		if (const_var.editAPIDataByResponse.data != undefined && const_var.editAPIDataByResponse.data.created_at <= "2023-10-13") {
			showRemainingWallOption = true;
		}
	}

	let l_to_h = 0;
	l_to_h = params.leanF_p_h;
	state.frontlentoEnds["Open"] = "Open";
	if (state.const_var.a_p_d_a.panel.length > 0) {
		for (let i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
			if (i == 0) {
				state.frontlentoEnds[i + 1 + " Panel (3')"] = i + 1;
			} else {
				let fit_i = (i + 1) * 3;
				state.frontlentoEnds[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
			}
		}
	}
	if (showRemainingWallOption) {
		state.frontlentoEnds["1/4 Closed"] = "One_Fourth_Close";
		state.frontlentoEnds["1/2 Closed"] = "Half_Close";
		state.frontlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.frontlentoEnds["Closed"] = "Close";
	state.frontlentoSides["Open"] = "Open";
	if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167 || params.m_s_n == 169 || params.m_s_n == 95) {
		state.frontlentoSides["Half Dutch End"] = "Half Dutch End";
		state.frontlentoSides["Half End"] = "Half End";
	}
	if (params.m_s_n == 1 || params.m_s_n == 155 || params.m_s_n == 162 || params.m_s_n == 17 || params.m_s_n == 186) {
		state.frontlentoSides["Half End"] = "Half End";
	}
	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		state.frontlentoSides["Gable"] = "Gable";
	}
	if (showRemainingWallOption) {
		state.frontlentoSides["1/4 Closed"] = "One_Fourth_Close";
		state.frontlentoSides["1/2 Closed"] = "Half_Close";
		state.frontlentoSides["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.frontlentoSides["Closed"] = "Close";

	l_to_h = params.leanB_p_h;
	state.backlentoEnds["Open"] = "Open";
	if (state.const_var.a_p_d_a.panel.length > 0) {
		for (let i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
			if (i == 0) {
				state.backlentoEnds[i + 1 + " Panel (3')"] = i + 1;
			} else {
				let fit_i = (i + 1) * 3;
				state.backlentoEnds[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
			}
		}
	}
	if (showRemainingWallOption) {
		state.backlentoEnds["1/4 Closed"] = "One_Fourth_Close";
		state.backlentoEnds["1/2 Closed"] = "Half_Close";
		state.backlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.backlentoEnds["Closed"] = "Close";
	state.backlentoSides["Open"] = "Open";
	if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167 || params.m_s_n == 169 || params.m_s_n == 95) {
		state.backlentoSides["Half Dutch End"] = "Half Dutch End";
		state.backlentoSides["Half End"] = "Half End";
	}
	if (params.m_s_n == 1 || params.m_s_n == 155 || params.m_s_n == 162 || params.m_s_n == 17 || params.m_s_n == 186) {
		state.backlentoSides["Half End"] = "Half End";
	}
	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		state.backlentoSides["Gable"] = "Gable";
	}
	if (showRemainingWallOption) {
		state.backlentoSides["1/4 Closed"] = "One_Fourth_Close";
		state.backlentoSides["1/2 Closed"] = "Half_Close";
		state.backlentoSides["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.backlentoSides["Closed"] = "Close";

	state.leftlentoEnds["Open"] = "Open";
	if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167 || params.m_s_n == 169 || params.m_s_n == 95) {
		state.leftlentoEnds["Half Dutch End"] = "Half Dutch End";
		state.leftlentoEnds["Half End"] = "Half End";
	}
	if (params.m_s_n == 1 || params.m_s_n == 155 || params.m_s_n == 162 || params.m_s_n == 17 || params.m_s_n == 186) {
		state.leftlentoEnds["Half End"] = "Half End";
	}
	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		state.leftlentoEnds["Gable"] = "Gable";
	}
	if (showRemainingWallOption) {
		state.leftlentoEnds["1/4 Closed"] = "One_Fourth_Close";
		state.leftlentoEnds["1/2 Closed"] = "Half_Close";
		state.leftlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.leftlentoEnds["Closed"] = "Close";

	l_to_h = params.lean_p_h;
	state.leftlentoSides["Open"] = "Open";
	if (state.const_var.a_p_d_a.panel.length > 0) {
		for (let i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
			if (i == 0) {
				state.leftlentoSides[i + 1 + " Panel (3')"] = i + 1;
			} else {
				let fit_i = (i + 1) * 3;
				state.leftlentoSides[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
			}
		}
	}
	if (showRemainingWallOption) {
		state.leftlentoSides["1/4 Closed"] = "One_Fourth_Close";
		state.leftlentoSides["1/2 Closed"] = "Half_Close";
		state.leftlentoSides["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.leftlentoSides["Closed"] = "Close";

	state.rightlentoEnds["Open"] = "Open";
	if (params.m_s_n == 9 || params.m_s_n == 3 || params.m_s_n == 167 || params.m_s_n == 169 || params.m_s_n == 95) {
		state.rightlentoEnds["Half Dutch End"] = "Half Dutch End";
		state.rightlentoEnds["Half End"] = "Half End";
	}
	if (params.m_s_n == 1 || params.m_s_n == 155 || params.m_s_n == 162 || params.m_s_n == 17 || params.m_s_n == 186) {
		state.rightlentoEnds["Half End"] = "Half End";
	}
	if (state.const_var.a_p_d_a.gable_end != undefined && state.const_var.a_p_d_a.gable_end.length > 0) {
		state.rightlentoEnds["Gable"] = "Gable";
	}
	if (showRemainingWallOption) {
		state.rightlentoEnds["1/4 Closed"] = "One_Fourth_Close";
		state.rightlentoEnds["1/2 Closed"] = "Half_Close";
		state.rightlentoEnds["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.rightlentoEnds["Closed"] = "Close";

	l_to_h = params.leanR_p_h;
	state.rightlentoSides["Open"] = "Open";
	if (state.const_var.a_p_d_a.panel.length > 0) {
		for (let i = 0; i < Math.floor((l_to_h - 1) / 3); i++) {
			if (i == 0) {
				state.rightlentoSides[i + 1 + " Panel (3')"] = i + 1;
			} else {
				let fit_i = (i + 1) * 3;
				state.rightlentoSides[i + 1 + " Panels (" + fit_i + "')"] = i + 1;
			}
		}
	}
	if (showRemainingWallOption) {
		state.rightlentoSides["1/4 Closed"] = "One_Fourth_Close";
		state.rightlentoSides["1/2 Closed"] = "Half_Close";
		state.rightlentoSides["3/4 Closed"] = "Three_Fourth_Close";
	}
	state.rightlentoSides["Closed"] = "Close";

	if (params.add_left_lean && Object.values(state.leftlentoSides).filter((data) => data == params.p_b_c_b_l).length == 0) {
		params.p_b_c_b_l = "Close";
	}
	if (params.add_right_lean && Object.values(state.rightlentoSides).filter((data) => data == params.p_b_c_b_r).length == 0) {
		params.p_b_c_b_r = "Close";
	}
	if (params.add_front_lean && Object.values(state.frontlentoEnds).filter((data) => data == params.p_b_c_b_f_l).length == 0) {
		params.p_b_c_b_f_l = "Close";
	}
	if (params.add_back_lean && Object.values(state.backlentoEnds).filter((data) => data == params.p_b_c_b_b_l).length == 0) {
		params.p_b_c_b_b_l = "Close";
	}

	updateJTrimForLeanTo(state);
};

export const updateLeantoWalls = (state, action) => {
	const { const_var } = state;

	if (action.leanType == "front") {
		state.params.add_left_front_lean_porch = false;
		state.params.add_right_front_lean_porch = false;
		state.params.add_storage_check_front = false;
		state.params.p_b_c_b_f_l = "Open";
		state.params.p_b_c_b_f_f = "Open";
		state.params.p_b_c_b_f_b = "Open";
		state.params.p_b_c_b_f_r = "Open";
		if (action.leanStyle == "gable") {
			const_var.wallNameArray["p_b_c_b_f_r"] = "right";
		} else {
			delete const_var.wallNameArray["p_b_c_b_f_r"];
		}
		if (state.params.add_front_lean == true) {
			cuBuilding.UpdateFrontLean();
			updateTemplateWidthF();
		}
	} else if (action.leanType == "left") {
		state.params.add_left_front_lean_porch = false;
		state.params.add_left_back_lean_porch = false;
		state.params.add_storage_check = false;
		state.params.p_b_c_b_l = "Open";
		state.params.p_b_c_b_l_f = "Open";
		state.params.p_b_c_b_l_b = "Open";
		state.params.p_b_c_b_l_r = "Open";
		if (action.leanStyle == "gable") {
			const_var.wallNameArray["p_b_c_b_l_r"] = "right";
		} else {
			delete const_var.wallNameArray["p_b_c_b_l_r"];
		}
		if (state.params.add_left_lean == true) {
			cuBuilding.UpdateLeftLean();
			updateTemplateWidthL();
		}
	} else if (action.leanType == "right") {
		state.params.add_right_front_lean_porch = false;
		state.params.add_right_back_lean_porch = false;
		state.params.add_storage_check_right = false;
		state.params.p_b_c_b_r = "Open";
		state.params.p_b_c_b_r_f = "Open";
		state.params.p_b_c_b_r_b = "Open";
		state.params.p_b_c_b_r_r = "Open";
		if (action.leanStyle == "gable") {
			const_var.wallNameArray["p_b_c_b_r_r"] = "right";
		} else {
			delete const_var.wallNameArray["p_b_c_b_r_r"];
		}
		if (state.params.add_right_lean == true) {
			cuBuilding.UpdateRightLean();
			updateTemplateWidthR();
		}
	} else if (action.leanType == "back") {
		state.params.add_left_back_lean_porch = false;
		state.params.add_right_back_lean_porch = false;
		state.params.add_storage_check_back = false;
		state.params.p_b_c_b_b_l = "Open";
		state.params.p_b_c_b_b_f = "Open";
		state.params.p_b_c_b_b_b = "Open";
		state.params.p_b_c_b_b_r = "Open";
		if (action.leanStyle == "gable") {
			const_var.wallNameArray["p_b_c_b_b_r"] = "right";
		} else {
			delete const_var.wallNameArray["p_b_c_b_b_r"];
		}
		if (state.params.add_back_lean == true) {
			cuBuilding.UpdateBackLean();
			updateTemplateWidthB();
		}
	}
};

const leanToWallOptionHelpers = {
	closeFrontLeanWalls: fullyWallEnclosedFrontLeanTo,
	closeBackLeanWalls: fullyWallEnclosedBackLeanTo,
	closeLeftLeanWalls: fullyWallEnclosedLeftLeanTo,
	closeRightLeanWalls: fullyWallEnclosedRightLeanTo,
	syncLeanToWallOptions: dynamicWallOptionsForLeanTo,
	refreshLeanToWalls: updateLeantoWalls,
	reducerBindings: {
		dynamicWallOptionsForLeanTo
	}
};

export default leanToWallOptionHelpers;
